
const ConditionalRender = ({ condition, children }) => {
    if (condition) return children;
    return null;
}

ConditionalRender.displayName = 'ConditionalRender';

export const If = (props) => {
    const condition = props.condition || false;
    const positive = props.then || null;
    const negative = props.else || null;

    return condition ? positive : negative;
}

export default ConditionalRender;
